<template>
  <div>
    <!-- Navigatsiya va Qidiruv -->
    <div class="nav-bar">
      <div class="nav-inner">
        <!-- Qidiruv -->
        <div class="search-box">
          <input
            type="text"
            v-model="filter"
            @input="onSearch"
            class="search-input"
            placeholder="Qidirish..."
          >
        </div>

        <!-- Tab tugmalari -->
        <div class="tab-group">
          <button @click="activeTab = 'package'" :class="['tab-btn', activeTab === 'package' ? 'active' : '']">Xizmatlar</button>
          <button @click="activeTab = 'product'" :class="['tab-btn', activeTab === 'product' ? 'active' : '']">Mahsulotlar</button>
        </div>
      </div>

      <!-- 1. Paket turi chiplari (faqat xizmatlar tabida) -->
      <div v-if="activeTab === 'package' && packageTypes.length > 0" class="brand-chips type-chips">
        <button
          v-if="typeFilterActive"
          class="brand-chip back-chip"
          @click="resetSelection"
          title="Brendlar ko'rinishiga qaytish"
        >
          <b-icon icon="arrow-left"></b-icon> Brendlar
        </button>
        <button
          :class="['brand-chip', { active: typeFilterActive && selectedTypeId === null }]"
          @click="selectTypeFilter(null)"
        >
          Barchasi <span class="chip-count">{{ filteredByModel.length }}</span>
        </button>
        <button
          v-for="pt in packageTypes"
          :key="pt.id"
          :class="['brand-chip', { active: sameId(selectedTypeId, pt.id) }]"
          @click="selectTypeFilter(pt.id)"
        >
          {{ pt.name }} <span class="chip-count">{{ countByType(pt.id) }}</span>
        </button>
      </div>

      <!-- Breadcrumb (brand/model tanlangan bo'lsa) -->
      <div v-if="selectedBrandId || showAllItems" class="browser-breadcrumb">
        <a href="#" @click.prevent="resetSelection">Brendlar</a>
        <template v-if="selectedBrandId">
          <span class="bc-sep">/</span>
          <a href="#" @click.prevent="backToBrand">{{ selectedBrandName }}</a>
        </template>
        <template v-if="selectedModelId">
          <span class="bc-sep">/</span><span class="bc-active">{{ selectedModelName }}</span>
        </template>
        <template v-if="showAllItems && !selectedBrandId">
          <span class="bc-sep">/</span><span class="bc-active">Barchasi</span>
        </template>
      </div>
    </div>

    <!-- Tanlov -->
    <div class="browser-body">

      <!-- 1. Brendlar katta kartalar (boshlang'ich holat — qidiruv bo'sh, tanlov yo'q) -->
      <div v-if="!inItemsView && !selectedBrandId" class="brand-grid">
        <div class="brand-card all-card" @click="showAll">
          <span class="all-icon">&#9776;</span>
          <span class="brand-label">Barchasi</span>
        </div>
        <div v-for="brand in brandList" :key="brand.id" class="brand-card" @click="selectBrand(brand)">
          <img v-if="brand.image" :src="imageUrl + brand.image" alt="" class="brand-img">
          <span class="brand-label">{{ brand.name }}</span>
        </div>
      </div>

      <!-- 2. Modellar katta kartalar (brand tanlangan, model tanlanmagan, qidiruv yo'q) -->
      <div v-else-if="!inItemsView && selectedBrandId && !selectedModelId" class="brand-grid">
        <div class="brand-card all-card" @click="showAllModelsOfBrand">
          <span class="all-icon">&#9776;</span>
          <span class="brand-label">Barchasi</span>
        </div>
        <div v-for="model in modelList" :key="model.id" class="brand-card" @click="selectModel(model)">
          <img v-if="model.image" :src="imageUrl + model.image" alt="" class="brand-img">
          <span class="brand-label">{{ model.name }}</span>
        </div>
        <div v-if="modelList.length === 0" class="empty-msg" style="grid-column: 1 / -1;">
          Modellar topilmadi
        </div>
      </div>

      <template v-else>

        <!-- Xizmat paketlari -->
        <div v-if="activeTab === 'package'">
          <div class="items-grid">
          <div
            v-for="pkg in filteredPackages" :key="pkg.id"
            class="item-card pkg-card"
            :class="{ 'item-selected': getServiceCount(pkg.id) > 0, 'item-pulse': lastAddedId === pkg.id }"
            @click="addPackage(pkg)"
          >
            <div class="ic-header">
              <div class="ic-name">{{ pkg.name }}</div>
              <div v-if="pkg.model" class="ic-sub">{{ pkg.model.name }}</div>
            </div>
            <div class="ic-prices">
              <div class="price-box active">
                <span class="p-tag" :class="saleType === 'optom' ? 'op' : 'ch'">
                  {{ saleType === 'optom' ? 'Optom' : 'Chakana' }}
                </span>
                <span class="p-amount">{{ formatDisplayPrice(packagePrice(pkg)) }}</span>
              </div>
            </div>
            <template v-if="getServiceCount(pkg.id) > 0">
              <div class="qty-controls" @click.stop>
                <button class="qty-btn-small minus" @click="decrementService(pkg.id)">−</button>
                <span class="qty-num">{{ getServiceCount(pkg.id) }}</span>
                <button class="qty-btn-small plus" @click="addPackage(pkg)">+</button>
              </div>
            </template>
            <button v-else class="add-btn">+</button>
          </div>
          <div v-if="filteredPackages.length === 0" class="empty-msg">Xizmat paketlari topilmadi</div>
          </div>
        </div>

        <!-- Mahsulotlar -->
        <div v-else>
        <!-- Papka yo'li (qidiruvda barcha papkalardan qidiriladi, shuning uchun yashiriladi) -->
        <div v-if="!searchKw" class="browser-breadcrumb folder-path">
          <a v-if="folderPath.length" href="#" @click.prevent="goToFolder(-1)">
            <b-icon icon="folder2-open"></b-icon> Barcha mahsulotlar
          </a>
          <span v-else class="bc-active"><b-icon icon="folder2-open"></b-icon> Barcha mahsulotlar</span>
          <template v-for="(f, i) in folderPath">
            <span :key="'s' + f.id" class="bc-sep">/</span>
            <a v-if="i < folderPath.length - 1" :key="f.id" href="#" @click.prevent="goToFolder(i)">{{ f.name }}</a>
            <span v-else :key="f.id" class="bc-active">{{ f.name }}</span>
          </template>
        </div>
        <div class="items-grid">
          <div
            v-for="item in productlist.filter(x => isFolder(x))" :key="'f' + item.id"
            class="item-card folder-card"
            title="Ochish uchun 2 marta bosing"
            @dblclick="openFolder(item)"
          >
            <b-icon icon="folder-fill" class="folder-icon"></b-icon>
            <div class="ic-name">{{ item.extra_name || item.name }}</div>
            <div class="ic-sub">2 marta bosing</div>
          </div>
          <div
            v-for="item in productlist.filter(x => !isFolder(x))" :key="item.id"
            class="item-card"
            :class="{ 'item-selected': getProductCount(item.id) > 0, 'item-pulse': lastAddedId === item.id }"
            @click="addProduct(item)"
          >
            <div class="ic-header">
              <div class="ic-name">{{ item.extra_name || item.name }}</div>
              <div class="ic-sub" :class="{ 'out-stock': Number(item.balance) <= 0 }">
                Qoldiq: {{ item.balance }}
                <button class="rev-mini" :class="{ danger: Number(item.balance) <= 0 }" @click.stop="openRevision(item)" title="Ombordagi haqiqiy miqdorni kiritish (qo'lda to'g'rilash)">
                  <b-icon icon="clipboard-check"></b-icon> Reviziya
                </button>
              </div>
            </div>
            <div class="ic-prices">
              <div class="price-box active">
                <span class="p-tag" :class="saleType === 'optom' ? 'op' : 'ch'">
                  {{ saleType === 'optom' ? 'Optom' : 'Chakana' }}
                </span>
                <span class="p-amount">{{ formatDisplayPrice(getPrice(item, saleType), getDollarPrice(item, saleType)) }}</span>
              </div>
            </div>
            <template v-if="getProductCount(item.id) > 0">
              <div class="qty-controls" @click.stop>
                <button class="qty-btn-small minus" @click="decrementProduct(item.id)">−</button>
                <span class="qty-num">{{ getProductCount(item.id) }}</span>
                <button class="qty-btn-small plus" @click="addProduct(item)">+</button>
              </div>
            </template>
            <button v-else class="add-btn">+</button>
          </div>
          <div v-if="productlist.length === 0" class="empty-msg">Mahsulot topilmadi</div>
        </div>
        </div>

      </template>
    </div>

    <!-- TEZ REVIZIYA MODALI -->
    <div v-if="revModal.show" class="rev-overlay" @click.self="closeRevision">
      <div class="rev-modal">
        <div class="rev-head">
          <h3><b-icon icon="clipboard-check"></b-icon> Reviziya</h3>
          <button class="rev-close" @click="closeRevision">&times;</button>
        </div>
        <div class="rev-body">
          <div class="rev-prod">{{ revModal.name }}</div>
          <div class="rev-row">
            <span>Tizimdagi qoldiq:</span>
            <b :class="{ 'out-stock': revModal.currentBalance <= 0 }">{{ revModal.currentBalance }}</b>
          </div>
          <label class="rev-label">Ombordagi haqiqiy miqdor</label>
          <input ref="revInput" type="number" min="0" v-model.number="revModal.realCount"
            class="rev-input" @keyup.enter="saveRevision" />
          <p class="rev-hint">
            <b-icon icon="info-circle"></b-icon>
            Kiritilgandan so'ng qoldiq to'g'rilanadi va "Reviziya" tarixiga yoziladi.
          </p>
        </div>
        <div class="rev-actions">
          <button class="rev-cancel" @click="closeRevision">Bekor</button>
          <button class="rev-save" :disabled="revModal.saving" @click="saveRevision">
            {{ revModal.saving ? 'Saqlanmoqda...' : 'Saqlash' }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'ProductBrowser',
  props: {
    saleType: { type: String, default: 'chakana' },
    currencyMode: { type: String, default: 'som' },
    dollarRate: { type: [Number, String], default: 1 },
    cart: { type: Array, default: () => [] },
  },
  emits: ['select-package', 'add-product', 'decrease-product', 'decrease-service', 'remove-item'],
  data() {
    return {
      activeTab: 'package',
      selectedBrandId: null,
      selectedModelId: null,
      showAllItems: false,
      filter: '',
      imageUrl: process.env.VUE_APP_BASE_URL + 'api/v1/uploads/',
      brandList: [],
      modelList: [],
      packages: [],
      packageTypes: [],
      selectedTypeId: null,
      typeFilterActive: false,
      productlist: [],
      // Mahsulot papkalari bo'ylab navigatsiya: 0 = ildiz, folderPath = [{id, name}, ...]
      currentFolderId: 0,
      folderPath: [],
      productRequestId: 0,
      searchTimer: null,
      lastAddedId: null,
      // Tez reviziya modali
      revModal: {
        show: false, item: null, productId: null, name: '',
        currentBalance: 0, realCount: 0, saving: false,
      },
    };
  },
  computed: {
    selectedBrandName() {
      const b = this.brandList.find(x => x.id === this.selectedBrandId);
      return b ? b.name : '';
    },
    selectedModelName() {
      const m = this.modelList.find(x => x.id === this.selectedModelId);
      return m ? m.name : '';
    },
    // Trimlangan, lowercase qidiruv kalit so'zi (markaziy)
    searchKw() {
      return (this.filter || '').trim().toLowerCase();
    },
    filteredByModel() {
      let list = this.packages;
      if (this.selectedBrandId !== null) {
        list = list.filter(p => p.model && this.sameId(p.model.brand_id, this.selectedBrandId));
      }
      if (this.selectedModelId !== null) {
        list = list.filter(p => this.sameId(p.model_id, this.selectedModelId));
      }
      if (this.searchKw) {
        list = list.filter(p => this.pkgMatchesKw(p));
      }
      return list;
    },
    filteredPackages() {
      let list = this.filteredByModel;
      if (this.typeFilterActive && this.selectedTypeId !== null) {
        list = list.filter(p => this.sameId(p.package_type_id, this.selectedTypeId));
      }
      return list;
    },
    // Qidiruv aktiv yoki "Barchasi" bosilganmi
    inItemsView() {
      return !!(
        this.searchKw
        || this.showAllItems
        || this.selectedModelId
        || (this.activeTab === 'package' && this.typeFilterActive)
      );
    },
  },
  watch: {
    // Brend/model ikkala tab uchun umumiy filtr bo'lib qoladi.
    activeTab(newTab) {
      if (newTab === 'product') {
        this.fetchProducts();
      } else {
        clearTimeout(this.searchTimer);
      }
    },
    // Qidiruv kalit so'zi o'zgarganda — items view avtomatik chiqadi (inItemsView dan).
    // Bo'shatilganda — oldingi brand/model holatiga qaytadi (showAllItems o'zgarmaydi)
    searchKw(/* newVal */) {
      // Side-effect yo'q; inItemsView computed barchasini boshqaradi
    }
  },
  mounted() {
    this.fetchBrands();
    this.fetchPackageTypes();
    this.fetchPackages();
    this.fetchProducts();
  },
  beforeDestroy() {
    clearTimeout(this.searchTimer);
  },
  methods: {
    formatSumma(s) { return Number(s || 0).toLocaleString(); },
    formatDisplayPrice(somPrice, dollarPrice = 0) {
      if (this.currencyMode === 'dollar') {
        const rate = Number(this.dollarRate) || 1;
        const value = Number(dollarPrice) > 0 ? Number(dollarPrice) : Number(somPrice || 0) / rate;
        return `$ ${value.toFixed(2)}`;
      }
      return `${this.formatSumma(somPrice)} so'm`;
    },
    // Package nomi/model/brand bo'yicha qidiruv mosligi (100% aniq)
    pkgMatchesKw(pkg) {
      const kw = this.searchKw;
      if (!kw) return true;
      if ((pkg.name || '').toLowerCase().includes(kw)) return true;
      if (pkg.model && (pkg.model.name || '').toLowerCase().includes(kw)) return true;
      if (pkg.model && pkg.model.brand && (pkg.model.brand.name || '').toLowerCase().includes(kw)) return true;
      // brand.name to'g'ridan-to'g'ri yuklanmagan bo'lsa, brandList'dan topib qidirish
      if (pkg.model && pkg.model.brand_id) {
        const b = this.brandList.find(x => x.id === pkg.model.brand_id);
        if (b && (b.name || '').toLowerCase().includes(kw)) return true;
      }
      return false;
    },
    addPackage(pkg) {
      this.$emit('select-package', pkg);
      this.lastAddedId = pkg.id;
      setTimeout(() => { this.lastAddedId = null; }, 400);
    },
    addProduct(item) {
      const inCart = this.getProductCount(item.id);
      const bal = Number(item.balance || 0);
      // Qoldiq yetarli emas — savatga qo'shishni cheklash va reviziya taklif qilish
      if (inCart >= bal) {
        this.openRevision(item);
        return;
      }
      this.$emit('add-product', item);
      this.lastAddedId = item.id;
      setTimeout(() => { this.lastAddedId = null; }, 400);
    },

    // ============== TEZ REVIZIYA (POS ichida) ==============
    openRevision(item) {
      this.revModal = {
        show: true,
        item,
        productId: item.id,
        name: item.extra_name || item.name || '',
        currentBalance: Number(item.balance || 0),
        realCount: Number(item.balance || 0),
        saving: false,
      };
      this.$nextTick(() => {
        if (this.$refs.revInput) { this.$refs.revInput.focus(); this.$refs.revInput.select(); }
      });
    },
    closeRevision() {
      this.revModal.show = false;
    },
    async saveRevision() {
      if (this.revModal.saving) return;
      const realCount = Number(this.revModal.realCount);
      if (isNaN(realCount) || realCount < 0) {
        alert("To'g'ri miqdor kiriting");
        return;
      }
      this.revModal.saving = true;
      try {
        const sklad_id = Number(localStorage.getItem('sklad_id'));
        // Joriy qoldiq + tannarxni aniqlash (ishonchli manbadan)
        let count = this.revModal.currentBalance;
        let body_price = 0;
        try {
          const pb = await axios.post('api/v1/product/price-balance', {
            product_id: this.revModal.productId, sklad_id,
          });
          count = Number(pb.data.balance || 0);
          // body_price — asl kirim (PriceRegister) dan, ishonchli manba.
          // delivery_price seriya orqali olinadi va oldingi reviziyalarda 0 bo'lib qolgan
          // bo'lishi mumkin, shu sabab fallback sifatida ishlatiladi.
          body_price = Number(pb.data.body_price || pb.data.delivery_price || 0);
        } catch (e) { /* mavjud qiymatlar bilan davom etamiz */ }

        await axios.post('api/v1/revision/quick', {
          product_id: this.revModal.productId,
          real_count: realCount,
          count,
          body_price,
          sklad_id,
        });

        // Ro'yxatdagi qoldiqni darhol yangilaymiz (savatga qo'shish ochilsin)
        if (this.revModal.item) this.revModal.item.balance = realCount;
        this.fetchProducts();
        this.closeRevision();
      } catch (e) {
        alert("Reviziyada xatolik: " + (e.response?.data?.message || e.response?.data || "Serverda xato"));
      } finally {
        this.revModal.saving = false;
      }
    },
    // ID solishtirishda tip xavfsizligi (string vs number ehtimoli)
    sameId(a, b) {
      if (a == null || b == null) return false;
      return String(a) === String(b);
    },
    getProductCount(id) {
      const p = this.cart.find(c => c.type === 'product' && this.sameId(c.id, id) && !c.from_service);
      return p ? Number(p.qty || p.count || 0) : 0;
    },
    getServiceCount(id) {
      const s = this.cart.find(c => c.type === 'service' && this.sameId(c.id, id));
      return s ? Number(s.qty || s.count || 0) : 0;
    },
    decrementProduct(id) {
      const item = this.cart.find(c => c.type === 'product' && this.sameId(c.id, id) && !c.from_service);
      if (!item) return;
      const idx = this.cart.indexOf(item);
      if (Number(item.qty || item.count || 0) > 1) {
        this.$emit('decrease-product', item);
      } else {
        this.$emit('remove-item', idx);
      }
    },
    decrementService(id) {
      const item = this.cart.find(c => c.type === 'service' && this.sameId(c.id, id));
      if (!item) return;
      const idx = this.cart.indexOf(item);
      if (Number(item.qty || item.count || 0) > 1) {
        this.$emit('decrease-service', item);
      } else {
        this.$emit('remove-item', idx);
      }
    },
    getPrice(item, type) {
      if (!item.price_register) return 0;
      return type === 'optom' ? item.price_register.optom_price : item.price_register.chakana_price;
    },
    getDollarPrice(item, type) {
      if (!item.price_register) return 0;
      return type === 'optom'
        ? item.price_register.optom_dollar_price
        : item.price_register.chakana_dollar_price;
    },
    packagePrice(pkg) {
      const type = this.saleType;
      const labor = type === 'optom' ? Number(pkg.labor_price_optom || 0) : Number(pkg.labor_price_chakana || 0);
      const redo = type === 'optom' ? Number(pkg.redo_price_optom || 0) : Number(pkg.redo_price_chakana || 0);
      return labor + redo;
    },
    async fetchBrands() {
      const res = await axios.get('api/v1/brand/');
      this.brandList = res.data;
    },
    selectTypeFilter(typeId) {
      this.selectedTypeId = typeId;
      this.typeFilterActive = true;
    },
    resetSelection() {
      this.selectedBrandId = null;
      this.selectedModelId = null;
      this.showAllItems = false;
      this.typeFilterActive = false;
      this.selectedTypeId = null;
      this.modelList = [];
    },
    async selectBrand(brand) {
      this.typeFilterActive = false;
      this.selectedTypeId = null;
      this.selectedBrandId = brand.id;
      this.selectedModelId = null;
      this.showAllItems = false;
      // Modellarni yuklash (keyingi bosqichda model kartalari chiqadi)
      try {
        const res = await axios.get(`api/v1/model/?brand_id=${brand.id}`);
        this.modelList = res.data || [];
      } catch (e) { this.modelList = []; }
    },
    async selectModel(model) {
      this.selectedModelId = model.id;
      this.showAllItems = false;
      // Mahsulot tabida — server-side qidirish; xizmat tabida — client-side filter (fetch shart emas)
      if (this.activeTab === 'product') {
        this.fetchProducts();
      }
    },
    async showAll() {
      this.showAllItems = true;
      this.typeFilterActive = false;
      this.selectedTypeId = null;
      this.selectedBrandId = null;
      this.selectedModelId = null;
      if (this.activeTab === 'product') {
        this.fetchProducts();
      }
    },
    async showAllModelsOfBrand() {
      // "Barchasi" — shu brenddagi barcha mahsulot/xizmatlarni ko'rsatish
      this.showAllItems = true;
      this.selectedModelId = null;
      if (this.activeTab === 'product') {
        this.fetchProducts();
      }
    },
    backToBrand() {
      // Modellar sahifasiga qaytish
      this.selectedModelId = null;
      this.showAllItems = false;
      this.typeFilterActive = false;
      this.selectedTypeId = null;
    },
    onSearch() {
      // Mahsulot tabida — server-side qidiruv
      // Xizmat tabida — client-side (filteredPackages computed avtomatik ishlaydi)
      if (this.activeTab === 'product') {
        clearTimeout(this.searchTimer);
        this.searchTimer = setTimeout(() => this.fetchProducts(), 250);
      }
    },
    isFolder(item) {
      return Number(item.is_folder) === 1;
    },
    openFolder(folder) {
      this.folderPath.push({ id: folder.id, name: folder.extra_name || folder.name });
      this.currentFolderId = folder.id;
      this.fetchProducts();
    },
    // index = -1 — ildizga, aks holda folderPath[index] papkasiga qaytish
    goToFolder(index) {
      this.folderPath = this.folderPath.slice(0, index + 1);
      this.currentFolderId = index >= 0 ? this.folderPath[index].id : 0;
      this.fetchProducts();
    },
    async fetchProducts() {
      const requestId = ++this.productRequestId;
      const skladId = localStorage.getItem('sklad_id');
      try {
        const res = await axios.post(`api/v1/product/all-price-balance/${this.currentFolderId}`, {
          sklad_id: skladId,
          keyword: this.filter || '',
          model_id: this.selectedModelId || 0,
          brand_id: this.selectedBrandId || 0,
          limit: 50,
          page: 1,
        });
        if (requestId === this.productRequestId) {
          this.productlist = res.data || [];
        }
      } catch (e) {
        if (requestId === this.productRequestId) this.productlist = [];
      }
    },
    async fetchPackages() {
      const res = await axios.get(`api/v1/repair_package?model_id=0`);
      this.packages = res.data;
    },
    async fetchPackageTypes() {
      try {
        const res = await axios.get('api/v1/package_types');
        this.packageTypes = res.data || [];
      } catch (e) {
        this.packageTypes = [];
      }
    },
    countByType(typeId) {
      return this.filteredByModel.filter(p => this.sameId(p.package_type_id, typeId)).length;
    },
  },
};
</script>

<style scoped>
/* Nav bar */
.nav-bar {
  background: white;
  border-radius: 14px;
  padding: 10px 14px;
  margin-bottom: 10px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.04);
}
.nav-inner {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}

/* Breadcrumb */
.breadcrumb-nav {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 13px;
  flex-shrink: 0;
}
.breadcrumb-nav a {
  color: #3b82f6;
  text-decoration: none;
  font-weight: 600;
}
.breadcrumb-nav a:hover { text-decoration: underline; }
.bc-sep { color: #cbd5e1; }
.bc-active { color: #64748b; font-weight: 600; }

/* Search */
.search-box { flex: 1; min-width: 120px; }
.search-input {
  width: 100%;
  border: none;
  background: #f1f5f9;
  border-radius: 10px;
  padding: 8px 14px;
  outline: none;
  font-size: 13px;
}
.search-input:focus {
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

/* Tabs */
.tab-group {
  display: flex;
  border-radius: 10px;
  overflow: hidden;
  flex-shrink: 0;
  box-shadow: 0 1px 3px rgba(0,0,0,0.06);
}
.tab-btn {
  background: #f1f5f9;
  color: #64748b;
  border: none;
  padding: 7px 18px;
  font-weight: 600;
  font-size: 13px;
  cursor: pointer;
  transition: 0.15s;
}
.tab-btn.active {
  background: #3b82f6;
  color: white;
}

/* Brand chiplar (header) */
.brand-chips {
  display: flex;
  gap: 6px;
  flex-wrap: wrap;
  margin-top: 10px;
  padding-top: 10px;
  border-top: 1px solid #f1f5f9;
}
.brand-chips.type-chips {
  background: #faf8ff;
  margin-top: 10px;
  margin-left: -14px;
  margin-right: -14px;
  padding: 10px 14px;
  border-radius: 10px;
  border-top: none;
}
.brand-chips.model-chips {
  border-top: none;
  padding-top: 4px;
  margin-top: 4px;
}
.chip-count {
  background: rgba(148, 163, 184, 0.15);
  color: inherit;
  padding: 1px 7px;
  border-radius: 10px;
  font-size: 10px;
  font-weight: 800;
  margin-left: 2px;
}
.brand-chip.active .chip-count {
  background: rgba(255, 255, 255, 0.3);
}
.brand-chip.back-chip {
  background: white;
  color: #475569;
  border-color: #cbd5e1;
  font-weight: 700;
}
.brand-chip.back-chip:hover {
  background: #f1f5f9;
  color: #3b82f6;
  border-color: #3b82f6;
}
.brand-chip {
  background: #f8fafc;
  color: #475569;
  border: 1px solid #e2e8f0;
  padding: 5px 12px;
  border-radius: 20px;
  font-weight: 600;
  font-size: 12px;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  transition: 0.15s;
  white-space: nowrap;
}
.brand-chip:hover {
  border-color: #3b82f6;
  color: #3b82f6;
  background: white;
}
.brand-chip.active {
  background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%);
  color: white;
  border-color: transparent;
  box-shadow: 0 2px 8px rgba(59, 130, 246, 0.3);
}
.model-chips .brand-chip.active {
  background: linear-gradient(135deg, #a142f4 0%, #8b2cf5 100%);
  box-shadow: 0 2px 8px rgba(161, 66, 244, 0.3);
}
.brand-chip-img {
  width: 20px;
  height: 20px;
  object-fit: contain;
  border-radius: 4px;
}
.all-icon-small {
  font-size: 14px;
  line-height: 1;
}

/* Breadcrumb */
.browser-breadcrumb {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 8px 2px 4px;
  font-size: 13px;
  font-weight: 600;
  border-top: 1px solid #f1f5f9;
  margin-top: 8px;
}
.browser-breadcrumb a {
  color: #3b82f6;
  text-decoration: none;
  cursor: pointer;
}
.browser-breadcrumb a:hover { text-decoration: underline; }
.browser-breadcrumb .bc-sep { color: #cbd5e1; margin: 0 2px; }
.browser-breadcrumb .bc-active { color: #475569; }

/* Brand katta kartalar grid */
.brand-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));
  gap: 10px;
}
.brand-card {
  background: white;
  border-radius: 14px;
  padding: 14px 10px;
  text-align: center;
  cursor: pointer;
  transition: 0.2s;
  border: 1.5px solid #f1f5f9;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  min-height: 110px;
}
.brand-card:hover {
  border-color: #3b82f6;
  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.15);
  transform: translateY(-2px);
}
.brand-img {
  width: 64px;
  height: 64px;
  object-fit: contain;
  border-radius: 10px;
}
.brand-label {
  font-weight: 700;
  font-size: 13px;
  color: #1e293b;
}
.brand-card.all-card {
  border: 2px dashed #3b82f6;
  background: #eff6ff;
}
.brand-card.all-card:hover {
  background: #dbeafe;
}
.all-icon {
  font-size: 36px;
  color: #3b82f6;
  line-height: 1;
}

/* Paket turi filterlari */
.type-filter {
  display: flex;
  gap: 6px;
  flex-wrap: wrap;
  margin-bottom: 10px;
  padding: 8px 10px;
  background: white;
  border-radius: 12px;
  box-shadow: 0 1px 4px rgba(0,0,0,0.04);
}
.type-btn {
  background: #f1f5f9;
  color: #475569;
  border: 1px solid transparent;
  padding: 6px 12px;
  border-radius: 10px;
  font-weight: 700;
  font-size: 12px;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  transition: 0.15s;
  white-space: nowrap;
}
.type-btn:hover {
  background: #e2e8f0;
  border-color: #cbd5e1;
}
.type-btn.active {
  background: linear-gradient(135deg, #a142f4 0%, #8b2cf5 100%);
  color: white;
  box-shadow: 0 2px 8px rgba(161, 66, 244, 0.3);
}
.type-count {
  background: rgba(255, 255, 255, 0.35);
  color: inherit;
  padding: 1px 7px;
  border-radius: 10px;
  font-size: 11px;
  font-weight: 800;
}
.type-btn:not(.active) .type-count {
  background: #cbd5e1;
  color: #475569;
}

/* Browser body — scrollable container */
.browser-body {
  max-height: calc(100vh - 280px);
  overflow-y: auto;
  overflow-x: hidden;
  padding: 2px 4px 8px 2px;
}
.browser-body::-webkit-scrollbar {
  width: 8px;
}
.browser-body::-webkit-scrollbar-track {
  background: transparent;
}
.browser-body::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 4px;
}
.browser-body::-webkit-scrollbar-thumb:hover {
  background: #94a3b8;
}

/* Items grid — auto-fill: ekran kengligiga qarab maksimal sig'diradi */
.items-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(185px, 1fr));
  gap: 8px;
}
@media (max-width: 400px) {
  .items-grid { grid-template-columns: 1fr; }
}

/* Kichik ekranlarda (mobil/planshet) — butun sahifa scroll */
@media (max-width: 991px) {
  .browser-body {
    max-height: none;
    overflow-y: visible;
  }
}

/* Item card */
.folder-card {
  align-items: center;
  justify-content: center;
  text-align: center;
  background: #fffbeb;
  border-color: #fde68a;
  user-select: none;
}
.folder-card:hover {
  background: #fef3c7;
  border-color: #fcd34d;
}
.folder-icon {
  font-size: 30px;
  color: #f59e0b;
}
.folder-path {
  margin-bottom: 10px;
}
.item-card {
  background: white;
  border-radius: 12px;
  padding: 9px 11px;
  cursor: pointer;
  transition: 0.15s;
  border: 1px solid #f1f5f9;
  display: flex;
  flex-direction: column;
  gap: 6px;
  position: relative;
}
.item-card:hover {
  background: #f8fafc;
  border-color: #e2e8f0;
  box-shadow: 0 2px 10px rgba(0,0,0,0.05);
}
.pkg-card {
  border-left: 3px solid #a142f4;
}

/* Tanlangan holat (savatda bor) */
.item-selected {
  background: linear-gradient(135deg, #ecfdf5 0%, #f0fdf4 100%) !important;
  border-color: #10b981 !important;
  box-shadow: 0 2px 10px rgba(16, 185, 129, 0.15) !important;
}
.item-selected.pkg-card {
  border-left: 3px solid #10b981;
  background: linear-gradient(135deg, #f3e8ff 0%, #faf5ff 100%) !important;
  border-color: #a142f4 !important;
  box-shadow: 0 2px 10px rgba(161, 66, 244, 0.15) !important;
}
.item-selected .ic-name {
  color: #065f46;
}
.item-selected.pkg-card .ic-name {
  color: #6b21a8;
}

/* Pulse animation qo'shilganda */
.item-pulse {
  animation: pulse-add 0.4s ease-out;
}
@keyframes pulse-add {
  0% { transform: scale(1); }
  50% { transform: scale(1.04); box-shadow: 0 6px 20px rgba(16, 185, 129, 0.3); }
  100% { transform: scale(1); }
}

.item-added {
  background: #f0e8ff !important;
  border-color: #a142f4;
}

.ic-header {
  padding-right: 30px;
}
.ic-name {
  font-weight: 700;
  font-size: 14px;
  color: #1e293b;
  line-height: 1.3;
  /* Uzun nomlar to'liq ko'rinsin — qisqartirish (clamp/ellipsis) olib tashlandi */
  word-break: break-word;
  overflow-wrap: anywhere;
}
.ic-sub {
  font-size: 12px;
  color: #94a3b8;
  margin-top: 2px;
}

/* Prices */
.ic-prices {
  display: flex;
  gap: 6px;
  flex-wrap: wrap;
}
.price-box {
  display: flex;
  align-items: center;
  gap: 5px;
  padding: 4px 8px;
  border-radius: 8px;
  background: #f8fafc;
  border: 1.5px solid transparent;
  transition: 0.15s;
}
.price-box.active {
  background: #ecfdf5;
  border-color: #10b981;
}
.p-tag {
  font-size: 10px;
  font-weight: 800;
  padding: 2px 5px;
  border-radius: 4px;
  line-height: 1;
}
.p-tag.ch { background: #dbeafe; color: #2563eb; }
.p-tag.op { background: #fef3c7; color: #d97706; }
.p-amount {
  font-weight: 800;
  font-size: 14px;
  color: #1e293b;
  white-space: nowrap;
}
.price-box.active .p-amount {
  color: #059669;
}

/* Add button */
.add-btn {
  position: absolute;
  top: 10px;
  right: 10px;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  border: 2px solid #10b981;
  background: white;
  color: #10b981;
  font-weight: bold;
  font-size: 16px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: 0.15s;
  line-height: 1;
}
.add-btn:hover {
  background: #10b981;
  color: white;
}
.add-btn.added {
  background: #a142f4;
  border-color: #a142f4;
  color: white;
}

/* Qty controls (savatda bor) */
.qty-controls {
  position: absolute;
  top: 8px;
  right: 8px;
  display: flex;
  align-items: center;
  gap: 4px;
  background: linear-gradient(135deg, #10b981 0%, #059669 100%);
  padding: 3px 4px;
  border-radius: 20px;
  box-shadow: 0 3px 10px rgba(16, 185, 129, 0.45);
  animation: badge-pop 0.2s ease-out;
}
.pkg-card .qty-controls {
  background: linear-gradient(135deg, #a142f4 0%, #8b2cf5 100%);
  box-shadow: 0 3px 10px rgba(161, 66, 244, 0.45);
}
.qty-btn-small {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  border: none;
  background: rgba(255, 255, 255, 0.25);
  color: white;
  font-weight: 800;
  font-size: 14px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 1;
  transition: 0.15s;
}
.qty-btn-small:hover {
  background: rgba(255, 255, 255, 0.45);
  transform: scale(1.1);
}
.qty-btn-small.minus:hover {
  background: #ef4444;
}
.qty-num {
  color: white;
  font-weight: 800;
  font-size: 13px;
  min-width: 20px;
  text-align: center;
}
@keyframes badge-pop {
  0% { transform: scale(0.5); opacity: 0; }
  100% { transform: scale(1); opacity: 1; }
}

.empty-msg {
  grid-column: 1 / -1;
  text-align: center;
  padding: 32px 0;
  color: #94a3b8;
  font-size: 13px;
}

/* Qoldiq yo'q holati */
.ic-sub.out-stock { color: #ef4444; font-weight: 800; }
.rev-mini {
  margin-left: 6px;
  border: 1px solid #c7d2fe;
  background: #eef2ff;
  color: #4f46e5;
  border-radius: 6px;
  font-size: 10px;
  font-weight: 800;
  padding: 2px 7px;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 3px;
  transition: 0.15s;
}
.rev-mini:hover { background: #4f46e5; color: #fff; border-color: #4f46e5; }
.rev-mini.danger { border-color: #fca5a5; background: #fff1f2; color: #dc2626; }
.rev-mini.danger:hover { background: #dc2626; color: #fff; border-color: #dc2626; }

/* Reviziya modali */
.rev-overlay {
  position: fixed;
  inset: 0;
  background: rgba(15, 23, 42, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2000;
}
.rev-modal {
  background: #fff;
  width: 380px;
  max-width: 92vw;
  border-radius: 16px;
  box-shadow: 0 20px 50px rgba(0, 0, 0, 0.25);
  overflow: hidden;
  animation: rev-pop 0.2s ease-out;
}
@keyframes rev-pop {
  from { transform: scale(0.94); opacity: 0; }
  to { transform: scale(1); opacity: 1; }
}
.rev-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 18px;
  border-bottom: 1px solid #f1f5f9;
}
.rev-head h3 {
  margin: 0;
  font-size: 16px;
  font-weight: 800;
  color: #0f172a;
  display: inline-flex;
  align-items: center;
  gap: 8px;
}
.rev-close {
  border: none;
  background: #f1f5f9;
  width: 30px;
  height: 30px;
  border-radius: 8px;
  font-size: 20px;
  color: #64748b;
  cursor: pointer;
}
.rev-close:hover { background: #e2e8f0; }
.rev-body { padding: 16px 18px; }
.rev-prod {
  font-weight: 700;
  font-size: 15px;
  color: #1e293b;
  margin-bottom: 10px;
}
.rev-row {
  display: flex;
  justify-content: space-between;
  font-size: 13px;
  color: #64748b;
  margin-bottom: 12px;
}
.rev-row b { color: #0f172a; }
.rev-row b.out-stock { color: #ef4444; }
.rev-label {
  display: block;
  font-size: 12px;
  font-weight: 700;
  color: #64748b;
  text-transform: uppercase;
  margin-bottom: 5px;
}
.rev-input {
  width: 100%;
  height: 44px;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  padding: 0 12px;
  font-size: 18px;
  font-weight: 800;
  text-align: center;
  outline: none;
}
.rev-input:focus {
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.12);
}
.rev-hint {
  display: flex;
  align-items: flex-start;
  gap: 6px;
  font-size: 11px;
  color: #94a3b8;
  margin: 10px 0 0;
}
.rev-actions {
  display: flex;
  gap: 10px;
  padding: 0 18px 18px;
}
.rev-cancel, .rev-save {
  flex: 1;
  height: 42px;
  border-radius: 10px;
  font-weight: 700;
  font-size: 14px;
  cursor: pointer;
  border: none;
}
.rev-cancel { background: #f1f5f9; color: #64748b; }
.rev-cancel:hover { background: #e2e8f0; }
.rev-save { background: #10b981; color: #fff; }
.rev-save:hover:not(:disabled) { background: #059669; }
.rev-save:disabled { opacity: 0.6; cursor: not-allowed; }
</style>
